var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseWhiteSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "xzsoa",
    d: "M727.82 413.96a.5.5 0 0 1 .5-.5h9.4a.5.5 0 0 1 0 1h-9.4a.5.5 0 0 1-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "xzsob",
    d: "M727.82 413.96a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-729 -410)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-45 733 414)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#xzsoa"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45 733 414)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#xzsob"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhiteSmall);
export default __webpack_public_path__ + "static/media/close-white-small.591c6765581c33550ce1c7565cbf47d2.svg";
export { ForwardRef as ReactComponent };